import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseLocationDeclarationView } from "./warehouseLocationDeclaration-view"
import { warehouse, WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";

export class WarehouseLocationDeclarationViewModel extends WindowViewModel {

    public getTitle(): string {
        return translate("warehouseLocationDeclaration-viewModel.warehouseLayout", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.locations = ObservableArray.create<location>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.warehouseSelector = new WarehouseSelector(this);
        this.warehouseSelector.onSelectionChanged = w => {
            this.selectedWarehouseId = w.id;
            this.selectedWarehouseName = w.title;
            this.selectedWarehouse = w;
            this.refresh();
        }
    }
    GetDefaultView(): View<ViewModel> {
        return new WarehouseLocationDeclarationView();
    }
    public getTypeId(): string {
        return "VM-A4E99567-86CB-4C37-AF62-FFA0D935F358"
    }
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector; } private _warehouseSelector: WarehouseSelector;

    public set selectedWarehouse(v: warehouse) { this._selectedWarehouse = v; } public get selectedWarehouse(): warehouse { return this._selectedWarehouse; } private _selectedWarehouse: warehouse;
    public set selectedWarehouseName(v: string) { this._selectedWarehouseName = v; } public get selectedWarehouseName(): string { return this._selectedWarehouseName; } private _selectedWarehouseName: string;
    public set selectedWarehouseId(v: string) { this._selectedWarehouseId = v; } public get selectedWarehouseId(): string { return this._selectedWarehouseId; } private _selectedWarehouseId: string;

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set locations(v: ObservableArray<location>) { this._locations = v; } public get locations(): ObservableArray<location> { return this._locations; } private _locations: ObservableArray<location>;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async addNew() {
        if (this.selectedWarehouse == null) {
            await this.messageBoxConfirmWarning(translate("warehouseLocationDeclaration-viewModel.warehouseError", {}), translate("warehouseLocationDeclaration-viewModel.notPossibleToRegister", {}));
            return;
        }
        let inserter = new LocationEditor(this, new InsertServerUpdater(), this.selectedWarehouse);
        inserter.onSuccess = () => this.refresh();
        this.showPopup(inserter);
    }

    async edit(location: location) {
        var updater = new LocationEditor(this, new UpdateServerUpdater(), this.selectedWarehouse);
        location.cloneTo(updater);
        updater.onSuccess = () => this.refresh();
        this.showPopup(updater);
    }
    async refresh() {
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryLocationManagementServices/GetWarehousePlaces', {
                FurtherQueryInfo: filteringInformation,
                WarehouseParty: this.selectedWarehouseId
            });
            this.locations.update(...result.WarehousePlaces.map((q, i) => {
                let r = new location(this);
                r.id = q.Id;
                r.name = q.Name;
                r.rowNumber = i + 1;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
}


export class location extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: WarehouseLocationDeclarationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent: WarehouseLocationDeclarationViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;



    clone(parent: ViewModel): location {
        let u = new location(this._typedParent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(location: location) {
        location.id = this.id;
        location.name = this.name;
    }

    edit() {
        this._typedParent.edit(this);
    }
}

interface IServerUpdate {
    execute(location: location, warehouse: warehouse): Promise<void>;
}

class InsertServerUpdater implements IServerUpdate {

    async execute(location: location, warehouse: warehouse): Promise<void> {
        try {
            let result = await ServerConnection.callServer('/Complex/InventoryLocationManagementServices/CreateNewWarehouseLocation', {
                WarehouseId: warehouse.id,
                LocationName: location.name
            });
            location.id = result.Id;
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}


class UpdateServerUpdater implements IServerUpdate {

    async execute(location: location, warehouse: warehouse): Promise<void> {
        try {
            let result = await ServerConnection.callServer('/Complex/InventoryLocationManagementServices/UpdateWarehouseLocation', {
                WarehousePlaceId: location.id,
                LocationName: location.name
            });
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}

export class LocationEditor extends location implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: WarehouseLocationDeclarationViewModel, updater: IServerUpdate, warehouse: warehouse) {
        super(parent);
        this.updater = updater;
        this._typedParent2 = parent;
        this.warehouse = warehouse;
    }

    closePopup() { }
    onSuccess() { }
    private warehouse: warehouse;
    private _typedParent2: WarehouseLocationDeclarationViewModel;
    public set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful; } private _isSuccessful: boolean;
    public set isFailed(v: boolean) { this._isFailed = v; } public get isFailed(): boolean { return this._isFailed; } private _isFailed: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    private updater: IServerUpdate;

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join("\n");
                await this.messageBoxConfirmWarning(errorMessage, translate("warehouseLocationDeclaration-viewModel.errorInRegistration", {}));
                return;
            }
            this.isLoading = true;
            await this.updater.execute(this, this.warehouse);
            await this.messageBoxConfirmSuccess(translate("warehouseLocationDeclaration-viewModel.successfullyRegistered", {}), translate("warehouseLocationDeclaration-viewModel.successfulOperation", {}));
            this.requestRefreshWindow();
            this.closePopup();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("warehouseLocationDeclaration-viewModel.operationErorr", {}), translate("warehouseLocationDeclaration-viewModel.error", {}));
        } finally {
            this.isLoading = false;
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(translate("warehouseLocationDeclaration-viewModel.nameError", {}));
        }
        return result;
    }

    closeSuccess() {
        this.onSuccess();
        this.closePopup();
    }
    closeFailed() {
        this.isFailed = false;
    }
}